export default __webpack_public_path__ + "static/media/key-hole.bc076476.svg";